import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  ADD_CURRENT_ORDER,
  CLEAR_CURRENT_ORDER,
  FETCH_TAXES_ORDER,
  FETCH_USERS_ORDER,
  ADD_CURRENT_USER,
  INCREASE_QUANTITY_CURRENT_ORDER,
  DECREASE_QUANTITY_CURRENT_ORDER,
  FETCH_DELIVERY_CHARGE_ORDER,
  CurrentOrderActionType,
  ADD_CURRENT_ORDER_INFO,
  AddCurrentOrderInfoAction,
} from '../types/currentOrderType';
import {
  SalesTax,
  User,
  currentOrder,
  currentOrderInfo,
} from 'src/types/model';

export const addCurrentOrder = (
  data: currentOrder
): CurrentOrderActionType => ({
  type: ADD_CURRENT_ORDER,
  payload: data,
});

export const addCurrentOrderInfo = (
  data: currentOrderInfo
): CurrentOrderActionType => ({
  type: ADD_CURRENT_ORDER_INFO,
  payload: data,
});

export const addCurrentUser = (
  data: {
    id: string;
    name: string;
    email: string | null;
    phone: number | null;
    image: string | null;
  } | null
): CurrentOrderActionType => ({
  type: ADD_CURRENT_USER,
  payload: data,
});

export const clearCurrentOrder = (): CurrentOrderActionType => ({
  type: CLEAR_CURRENT_ORDER,
});

export const fetchTaxesOrder = (data: SalesTax[]): CurrentOrderActionType => ({
  type: FETCH_TAXES_ORDER,
  payload: data,
});

export const fetchDeliveryChargeOrder = (
  data: number
): CurrentOrderActionType => ({
  type: FETCH_DELIVERY_CHARGE_ORDER,
  payload: data,
});

export const fetchUsersOrder = (data: User[]): CurrentOrderActionType => ({
  type: FETCH_USERS_ORDER,
  payload: data,
});

export const increaseQuantityOrder = (data: {
  id: string;
  quantity: number;
}): CurrentOrderActionType => ({
  type: INCREASE_QUANTITY_CURRENT_ORDER,
  payload: data,
});

export const decreaseQuantityOrder = (data: {
  id: string;
  quantity: number;
  decreaseLimit?: number;
}): CurrentOrderActionType => ({
  type: DECREASE_QUANTITY_CURRENT_ORDER,
  payload: data,
});

export const fetchTaxes = () => {
  return async (dispatch: Dispatch<CurrentOrderActionType>) => {
    try {
      const request = await Service.get('/settings/extraCharges');
      const data: SalesTax[] = request?.data?.data?.extraCharges;
      dispatch(fetchTaxesOrder(data));
    } catch (error: any) {
      throw new Error('Failed to fetch taxes');
    }
  };
};

export const fetchDeliveryCharge = () => {
  return async (dispatch: Dispatch<CurrentOrderActionType>) => {
    try {
      const request = await Service.get('/settings');
      const data: any = request?.data?.settings?.deliveryCharge;
      if (data) {
        dispatch(fetchDeliveryChargeOrder(data));
      } else {
        dispatch(fetchDeliveryChargeOrder(0));
      }
    } catch (error: any) {
      dispatch(fetchDeliveryChargeOrder(0));
      throw new Error('Failed to fetch delivery charge');
    }
  };
};

export const fetchUsers = () => {
  return async (dispatch: Dispatch<CurrentOrderActionType>) => {
    try {
      const request = await Service.get('/users/own');
      const data: User[] = request?.data?.data;
      dispatch(fetchUsersOrder(data));
    } catch (error: any) {
      throw new Error('Failed to fetch taxes');
    }
  };
};
